import { Grid } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { getChartData, getEmptyStateChart } from '../../../helpers/chartHelper';
import getColourSchemeBasedOnStatus from '../../../helpers/getColourSchemeBasedOnStatus';
import { Analytics } from '../../../hooks/useAnalyticsQuery';

const WorkshopStatusLineChart = (props: { data: Analytics; loadingDataInterval: Array<any> }) => {
  const { t } = useTranslation();
  const { data = {}, loadingDataInterval = [] } = props;
  const loadingData = getEmptyStateChart(loadingDataInterval, [
    'w_pre_registered_absolute',
    'w_registered_absolute',
    'w_verified_absolute',
    'w_activated_absolute',
  ]);
  const chartData = getChartData(data, ['w_pre_registered_absolute', 'w_registered_absolute', 'w_verified_absolute', 'w_activated_absolute']);

  return (
    <Grid>
      <ResponsiveContainer aspect={3.1}>
        <LineChart
          width={500}
          height={300}
          data={chartData.length === 0 ? loadingData : chartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="label" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            strokeWidth={4}
            isAnimationActive={true}
            animateNewValues={true}
            name={t(`controlling:charts.workshop.status.pre_registered.legend`)}
            type="monotone"
            dataKey="w_pre_registered_absolute"
            stroke={getColourSchemeBasedOnStatus('preregistered')}
          />
          <Line
            strokeWidth={4}
            isAnimationActive={true}
            animateNewValues={true}
            name={t(`controlling:charts.workshop.status.verified.legend`)}
            type="monotone"
            dataKey="w_verified_absolute"
            stroke={getColourSchemeBasedOnStatus('account_setup')}
          />
          <Line
            strokeWidth={4}
            isAnimationActive={true}
            animateNewValues={true}
            name={t(`controlling:charts.workshop.status.registered.legend`)}
            type="monotone"
            dataKey="w_registered_absolute"
            stroke={getColourSchemeBasedOnStatus('registered')}
          />
          <Line
            strokeWidth={4}
            isAnimationActive={true}
            animateNewValues={true}
            name={t(`controlling:charts.workshop.status.activated.legend`)}
            type="monotone"
            dataKey="w_activated_absolute"
            stroke={getColourSchemeBasedOnStatus('active')}
          />
        </LineChart>
      </ResponsiveContainer>
    </Grid>
  );
};

export default WorkshopStatusLineChart;
